import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryV1 } from './baseQueryV1';

export const employeeLeaveApi = createApi({
  reducerPath: 'employeeLeaveApi',
  baseQuery: baseQueryV1,
  tagTypes: ['EmployeeLeave'],
  endpoints: (builder) => ({
    getEmployeeLeaves: builder.query({
      query: (params) => ({
        url: 'leaves',
        method: 'GET',
        params,
      }),
      transformResponse: (res) => res?.data,
      providesTags: ['EmployeeLeave'],
    }),
    getEmployeeLeavesByYear: builder.query({
      query: (params) => ({
        url: 'leaves/yearly',
        method: 'GET',
        params,
      }),
      transformResponse: (res) => {
        return res?.data;
      },
      providesTags: ['EmployeeLeave'],
    }),
    getEmployeeLeavesStats: builder.query({
      query: (params) => ({
        url: 'leaves/stats',
        method: 'GET',
        params,
      }),
      transformResponse: (res) => {
        return res?.data;
      },
      providesTags: ['EmployeeLeave'],
    }),
    getEmployeeLeaveById: builder.query({
      query: (id) => ({
        url: `leaves/${id}`,
        method: 'GET',
      }),
      transformResponse: (res) => res?.data,
      providesTags: ['EmployeeLeave'],
    }),
    addEmployeeLeave: builder.mutation({
      query: (payload) => ({
        url: 'leaves',
        method: 'POST',
        body: payload,
      }),
      transformResponse: (res) => res?.data,
      invalidatesTags: ['EmployeeLeave'],
    }),
    updateEmployeeLeave: builder.mutation({
      query: ({ id, ...payload }) => ({
        url: `leaves/${id}`,
        method: 'PUT',
        body: payload,
      }),
      transformResponse: (res) => res?.data,
      invalidatesTags: ['EmployeeLeave'],
    }),
    deleteEmployeeLeave: builder.mutation({
      query: (id) => ({
        url: `leaves/${id}`,
        method: 'DELETE',
      }),
      transformResponse: (res) => res?.data,
      invalidatesTags: ['EmployeeLeave'],
    }),
    approveEmployeeLeave: builder.mutation({
      query: (id) => ({
        url: `leaves/${id}/approve`,
        method: 'PUT',
      }),
      transformResponse: (res) => res?.data,
      invalidatesTags: ['EmployeeLeave'],
    }),
    rejectEmployeeLeave: builder.mutation({
      query: ({ id, reason }) => ({
        url: `leaves/${id}/reject`,
        method: 'PUT',
        body: { reason: reason },
      }),
      transformResponse: (res) => res?.data,
      invalidatesTags: ['EmployeeLeave'],
    }),
    cancelEmployeeLeave: builder.mutation({
      query: ({ id, reason, remainAll = false }) => ({
        url: `leaves/${id}/cancel`,
        method: 'PUT',
        body: {
          reason,
          remainAll,
        },
      }),
      transformResponse: (res) => res?.data,
      invalidatesTags: ['EmployeeLeave'],
    }),
    getEmployeeLeaveByUserId: builder.query({
      query: (id) => ({
        url: `leaves/user/${id}`,
        method: 'GET',
      }),
      transformResponse: (res) => res?.data,
      providesTags: ['EmployeeLeave'],
    }),
    getUnplannedLeaves: builder.query({
      query: (params) => ({
        url: 'leaves/unplanned',
        method: 'GET',
        params,
      }),
      transformResponse: (res) => res?.data,
      providesTags: ['EmployeeLeave'],
    }),
    getTodayUnplannedLeaves: builder.query({
      query: () => ({
        url: 'leaves/unplanned/today',
        method: 'GET',
      }),
      transformResponse: (res) => res?.data,
      providesTags: ['EmployeeLeave'],
    }),
    getUpcomingLeaves: builder.query({
      query: () => ({
        url: `leaves/upcoming`,
        method: 'GET',
      }),
      transformResponse: (res) => res?.data,
      providesTags: ['EmployeeLeave'],
    }),
    getAppreciationMessage: builder.query({
      query: (id) => ({
        url: `leaves/appreciation-message/${id}`,
        method: 'GET',
      }),
      transformResponse: (res) => res?.data,
      providesTags: ['EmployeeLeave'],
    }),
  }),
});

export const {
  useGetEmployeeLeavesQuery,
  useGetEmployeeLeaveByIdQuery,
  useAddEmployeeLeaveMutation,
  useUpdateEmployeeLeaveMutation,
  useDeleteEmployeeLeaveMutation,
  useApproveEmployeeLeaveMutation,
  useRejectEmployeeLeaveMutation,
  useCancelEmployeeLeaveMutation,
  useGetEmployeeLeavesByYearQuery,
  useGetEmployeeLeavesStatsQuery,
  useGetEmployeeLeaveByUserIdQuery,
  useGetUnplannedLeavesQuery,
  useGetUpcomingLeavesQuery,
  useGetTodayUnplannedLeavesQuery,
  useGetAppreciationMessageQuery,
} = employeeLeaveApi;
